import { AccountItemBlock } from "@components/account/AccountItem";
import CompanionPermissions from "@components/companion/CompanionSettings/settings/CompanionPermissions";
import CompanionBillingView from "@components/companion-v2/CompanionBillingView";

export default function CompanionSettings() {
  return (
    <div className="flex flex-col gap-lg">
      <CompanionBillingView />
      <AccountItemBlock
        title="Permissions"
        desc="Actions Companion can run without asking again."
      >
        <CompanionPermissions />
      </AccountItemBlock>
    </div>
  );
}
